<script setup>
import notification from "@/utils/plugins/NotificationService";
import { ref } from "vue";


// eslint-disable-next-line no-undef
const emit = defineEmits(["closeDialog", "saveRequest"]);

// eslint-disable-next-line no-unused-vars, no-undef
const props = defineProps({
  employees: {
    type: Array,
    default: () => [],
  },
  materialTypes: {
    type: Array,
    default: () => [],
  },
});

const requestForm = ref({
  materialType: null,
  description: "",
  systemsComment: "",
});

const closeDialog = () => {
  emit("closeDialog");
};

const saveEntry = () => {
  if (!requestForm.value.materialType) {
    notification.addNotification({
      type: "error",
      message: "Tienes que seleccionar el tipo de material.",
      duration: 5000,
    });
    return;
  }

  emit("saveRequest", { ...requestForm.value });
};
</script>

<template>
  <div>
    <div class="header">
      <img style="width: 30px; margin-bottom: 14px;" src="@/assets/icons/box-blue.svg">
      <span class="header-title pl-4">
        Solicitar material
      </span>
    </div>

    <div class="row f-flex">
      <div class="col-12 el-col-xs-24 mt-3">
        <label for="requestType" class="w-100">Tipo de material</label>
        <el-select popper-class="material-modal-select" id="requestType" v-model="requestForm.materialType" filterable
          placeholder="Seleccione un tipo de material" :value-key="'id'">
          <el-option v-for="materialType in materialTypes" :key="materialType.id || materialType['@id']"
            :label="materialType.name" :value="materialType" />
        </el-select>
      </div>
      <div class="col-12 mt-3">
        <label for="requestDescription" class="w-100">Descripción material</label>
        <el-input id="requestDescription" type="textarea" v-model="requestForm.description"
          placeholder="Escribe tus comentarios" :rows="5" class="custom-textarea" />
      </div>
      <div class="col-12 mt-3">
        <label for="requestSystemsComment" class="w-100">Comentario de sistemas</label>
        <el-input id="requestSystemsComment" type="textarea" v-model="requestForm.systemsComment"
          placeholder="Escribe un comentario de sistemas" :rows="4" class="custom-textarea" />
      </div>
    </div>

    <div class="row footer">
      <div class="col-md-12 mt-4 footer-container">
        <div class="d-flex justify-content-end gap-3">
          <div class="col-md-3">
            <button class="btn btn-block btn_yellow edit-button" @click="closeDialog">
              Cancelar
            </button>
          </div>
          <div class="col-md-3">
            <button type="submit" class="btn btn-block btn_red edit-button" @click="saveEntry">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header-title {
  font-size: 30px;
  margin-left: 5px;
  font-weight: 800;
  letter-spacing: -0.05em;
  color: #474ce6;
}

.custom-textarea:deep(.el-textarea__inner) {
  font-size: 14px !important;
  border-radius: 20px;
}

.footer-container {
  margin-left: -10px;
}

@media (max-width: 767.98px) {
  .footer-container {
    margin-left: 0 !important;
  }

  .row {
    margin-left: 0;
    margin-right: 0;
  }

  [class*="col-"] {
    padding-left: 0;
    padding-right: 0;
  }

  .footer {
    .d-flex {
      flex-direction: column;
      gap: 0.75rem !important;
    }

    .col-md-3 {
      width: 100%;
    }

    .edit-button {
      width: 100%;
    }
  }
}

@media (max-width: 500px) {
  .header-title {
    font-size: 25px;
  }
}
</style>
